import { Collapse, Empty, Flex, Image } from "antd";
import React from "react";
import styled from "styled-components";
import Location from "../../assets/Icons/locations.svg";
import Calendar from "../../assets/Icons/calendar.svg";
import Dollar from "../../assets/Icons/wallet.svg";
import Note from "../../assets/Icons/notes.svg";
import Holiday from "../../assets/Icons/holiday.svg";
import { formatDateOnly } from "../../utils/date";

const StyledItemContainer = styled.div`
  background-color: #e1e2eb;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 10px;
  font-size: 13px;
  width: 100%;
  /* border: 1px solid #664d7a; */
  .details {
    color: green;
    font-size: 12px;
  }
  span {
    font-weight: 600;
  }
`;

const StyledTimeContainer = styled.div`
  width: 100px;
  height: auto;
  padding: 10px;
  font-size: 13px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  box-shadow: -1px 1px 8px rgba(128, 128, 128, 0.2);
  border: 1px solid #ccc;
`;

function DetailsView({ data, imageBase }) {
  const ListItems = ({ acts }) => (
    <div className="pl-5">
      <Flex wrap={true} gap="middle">
        {acts?.map((act, index) =>
          act?.title ? (
            <Flex
              gap="small"
              key={index}
              style={{ marginBottom: "10px", width: "47%" }}
            >
              <StyledTimeContainer>
                {(act.title === "From" || act.title === "To") && (
                  <Image
                    width={25}
                    height={25}
                    src={Calendar}
                    preview={false}
                  />
                )}
                {(act.title === "Source" ||
                  act.title === "Location") && (
                  <Image
                    width={25}
                    height={25}
                    src={Location}
                    preview={false}
                  />
                )}
                {act.title.toLowerCase().includes("destination") && (
                  <Image
                    width={25}
                    height={25}
                    src={Location}
                    preview={false}
                  />
                )}
                {act.title.toLowerCase().includes("vacation") && (
                  <Image width={25} height={25} src={Holiday} preview={false} />
                )}
                {act.title === "Budget" && (
                  <Image width={25} height={25} src={Dollar} preview={false} />
                )}
                {act.title === "Assistance" && (
                  <Image width={25} height={25} src={Note} preview={false} />
                )}
                {act.image && (
                  <Image
                    width={35}
                    height={35}
                    src={`${imageBase}${act.image}`}
                    preview={false}
                  />
                )}
                {!(
                  [
                    "From",
                    "To",
                    "Source",
                    "Destination",
                    "Location",
                    "Budget",
                    "Assistance",
                  ].includes(act.title) ||
                  ["destination", "vacation"].some((keyword) =>
                    act.title.toLowerCase().includes(keyword)
                  ) ||
                  act.image
                ) && (
                  <Image width={25} height={25} src={Note} preview={false} />
                )}
              </StyledTimeContainer>
              <StyledItemContainer>
                <span>{act.title}</span>
                {act.title === "From" || act.title === "To" ? (
                  <p className="details mt-2">{formatDateOnly(act.answer)}</p>
                ) : (
                  <p className="details mt-2">
                    {act.title === "Specific Area/Landmark" ? (act.answer ? act.answer : "-") : 
                    Array.isArray(act.answer)
                      ? act.answer.map((item, index) => (
                          <p key={index}>{item}</p>
                        ))
                      : ` ${act.answer}`
                    }
                    
                  </p>
                )}
              </StyledItemContainer>
            </Flex>
          ) : null
        )}
      </Flex>
      {acts?.length === 0 && <Empty />}
    </div>
  );

  const items = [
    {
      key: "1",
      label: "Basic Details",
      children: <ListItems acts={data?.basic_details || []} />,
      style: {
        marginBottom: 18,
        boxShadow: "-1px 1px 8px rgba(128, 128, 128, 0.2)",
        border: "1px solid #ccc",
        borderRadius: "10px",
      },
    },
    ...(data?.customized_preferences?.length
      ? [
          {
            key: "2",
            label: "Customized Preferences",
            children: <ListItems acts={data.customized_preferences} />,
            style: {
              marginBottom: 18,
              boxShadow: "-1px 1px 8px rgba(128, 128, 128, 0.2)",
              border: "1px solid #ccc",
              borderRadius: "10px",
            },
          },
        ]
      : []),
  ];

  return (
    <div>
      <Collapse
        bordered={false}
        defaultActiveKey={["1", "2"]}
        style={{ background: "#ffffff" }}
        items={items}
        expandIconPosition={"end"}
      />
    </div>
  );
}

export default DetailsView;
